import { render } from "./apps.vue?vue&type=template&id=3d6ebd9a&ts=true"
import script from "./apps.vue?vue&type=script&lang=ts"
export * from "./apps.vue?vue&type=script&lang=ts"

import "./apps.vue?vue&type=style&index=0&id=3d6ebd9a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__